var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Имя клиента")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newData.client.name,
                expression: "newData.client.name",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "ФИО" },
            domProps: { value: _vm.newData.client.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newData.client, "name", $event.target.value)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("label", [_vm._v("Номер телефона")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newData.client.phone_num,
              expression: "newData.client.phone_num",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text", placeholder: "999 999 999" },
          domProps: { value: _vm.newData.client.phone_num },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.newData.client, "phone_num", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "form-group" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newData.type_id,
                  expression: "newData.type_id",
                },
              ],
              staticClass: "form-control",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    _vm.newData,
                    "type_id",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            _vm._l(_vm.requestTypes, function (t) {
              return _c("option", { domProps: { value: t.id } }, [
                _vm._v(_vm._s(t.title)),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        +_vm.newData.type_id === 4
          ? _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Город клиента")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newData.city_id,
                      expression: "newData.city_id",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.newData,
                        "city_id",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c("option", { attrs: { disabled: "", value: "0" } }, [
                    _vm._v("Выберите город клиента"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.sortArray(_vm.$AllCities, "name"), function (t) {
                    return _c("option", { domProps: { value: t.id } }, [
                      _vm._v(_vm._s(t.name)),
                    ])
                  }),
                ],
                2
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", [_vm._v("Препарат в системе")]),
            _vm._v(" "),
            _c("DrugSearchNew", {
              ref: "drugSearch",
              attrs: { onSelect: (d) => (_vm.newData.drug.id = d?.id) },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Новый препарат")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newData.drug.title,
                expression: "newData.drug.title",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Название препарата" },
            domProps: { value: _vm.newData.drug.title },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newData.drug, "title", $event.target.value)
              },
            },
          }),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newData.comment,
              expression: "newData.comment",
            },
          ],
          staticClass: "form-control",
          attrs: { placeholder: "комментарий к записи", rows: "4" },
          domProps: { value: _vm.newData.comment },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.newData, "comment", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "text-right mt-2" },
      [
        _c(
          "v-popover",
          { staticClass: "d-inline", attrs: { "auto-hide": true } },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-success",
                attrs: { type: "button" },
              },
              [_vm._v("Сохранить")]
            ),
            _vm._v(" "),
            _c("template", { slot: "popover" }, [
              _c(
                "div",
                { staticClass: "p-2" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "alert alert-info p-1 mb-1" }, [
                      _c("strong", [_vm._v("Проверьте тип запроса")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newData.type_id,
                            expression: "newData.type_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newData,
                              "type_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.requestTypes, function (t) {
                        return _c("option", { domProps: { value: t.id } }, [
                          _vm._v(_vm._s(t.title)),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить",
                      type: "button",
                      loading: _vm.btnLoading,
                      color: "white",
                      onClick: () => _vm.saveRequest(),
                      className: "btn btn-success",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Клиент")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Препарат")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert-info pt-1" }, [
      _c("strong", [_vm._v("Тип запроса")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }